export default __webpack_public_path__ + "static/logo-mobile-01cd246b1b8f382a620ea217b6ede931.svg";